export default __webpack_public_path__ + "static/media/renaldo_andrews_feature3.eafbb41b.jpeg";